import React from "react";
import { getBasePcode } from "@/modules/gamePcode";
import { IPopupResultHistoryProps } from "@/types/PopupResultHistoryTypes";

import img_back_card from "@/assets/img/img_back_card.png";

export default class BasePopupResultHistoryClass extends React.PureComponent<IPopupResultHistoryProps> {
	protected imgBackCard = img_back_card;

	get basePcode() {
		return getBasePcode(this.props.activeGame.pcode);
	}
}